export const SOLE_PROPRIETOR = "Sole Proprietorship";
export const TAX_ID_PLACEHOLDER = "00-0000000";
export const CURRENCY_FIELDS = ["averageSale", "highestSale", "cardSales"];

export const hasSoleProprietorEin = application => {
  if (application.soleProprietorHasEin === "Yes") return true;
  if (application.soleProprietorHasEin === "No") return false;
  return (
    !!application.federalTaxId &&
    application.federalTaxId !== TAX_ID_PLACEHOLDER
  );
};

export const applyTaxIdChoice = application => {
  if (
    application.ownershipType === SOLE_PROPRIETOR &&
    !hasSoleProprietorEin(application)
  ) {
    application.federalTaxId = TAX_ID_PLACEHOLDER;
  }
  return application;
};

export const joinPrincipalName = application =>
  [application.firstName, application.lastName]
    .map(value => (value || "").trim())
    .filter(Boolean)
    .join(" ");

// Legacy editors have no EIN choice toggle. A direct EIN edit must update the
// choice as well, otherwise a previous No silently overwrites the new value.
export const reconcileLegacyMerchantEdit = (application, name) => {
  if (application.ownershipType !== SOLE_PROPRIETOR) return application;
  if (name === "federalTaxId") {
    application.soleProprietorHasEin = application.federalTaxId &&
      application.federalTaxId !== TAX_ID_PLACEHOLDER ? "Yes" : "No";
  }
  if (name === "firstName" || name === "lastName") {
    application.legalBusinessName = joinPrincipalName(application);
  }
  if (name === "legalBusinessName") {
    if ((application.legalBusinessName || "").trim() === joinPrincipalName(application)) return application;
    const [firstName = "", ...remaining] = (application.legalBusinessName || "").trim().split(/\s+/);
    application.firstName = firstName;
    application.lastName = remaining.join(" ");
  }
  return application;
};

// A raw decimal string is the storage/API contract; commas and dollars are UI only.
// null means reject the edit rather than silently change its numeric meaning.
export const currencyInput = value => {
  const text = String(value).replace(/[$,\s]/g, "");
  if (!/^\d{0,6}(\.\d{0,2})?$/.test(text)) return null;
  return text.startsWith(".") ? `0${text}` : text;
};

export const formatCurrencyInput = (value, fixed = false) => {
  if (value === "" || value == null) return "";
  const raw = String(value);
  if (!/^\d+(\.\d{0,2})?$/.test(raw)) return raw;
  const [whole, cents] = raw.split(".");
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return (
    grouped +
    (fixed
      ? `.${(cents || "").padEnd(2, "0")}`
      : cents !== undefined
      ? `.${cents}`
      : "")
  );
};

export const formatMoney = value => {
  const number = Number(value);
  return Number.isFinite(number)
    ? `$${number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`
    : "—";
};
